import React, { Component } from 'react';
import './GCalendar.css';
import { getMonthAvailabilityByRoom } from '../../services/bookings';
import { Icon } from 'element-react';

class GCalendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      currentYear: new Date().getFullYear(),
      currentMonth: new Date().getMonth(),
      days: ['L', 'M', 'X', 'J', 'V', 'S', 'D'],
      padding: [],
      numbers: [],
      changingDate: [],
      loadingData: true,
    };

    this.lastMonth = this.lastMonth.bind(this);
    this.nextMonth = this.nextMonth.bind(this);
    this.updateCalendar = this.updateCalendar.bind(this);
  }

  loadData(availabilities) {
    if (availabilities.length > 0) this.setState({ loadingData: true });
    const first_day = new Date(this.state.currentYear, this.state.currentMonth, 1);
    const last_day = new Date(this.state.currentYear, this.state.currentMonth + 1, 0);

    let padding = first_day.getDay();

    if (padding === 0) padding = 6;
    else padding -= 1;

    const arr_padding = [];
    for (let i = 0; i < padding; i++) arr_padding.push({});

    let numbers = [];
    for (let i = 1; i <= last_day.getDate(); i++) {
      const dd = new Date(this.state.currentYear, this.state.currentMonth, i);
      let state = 'available';
      if (availabilities.length > 0 && availabilities[i - 1]) {
        if (availabilities[i - 1].type === 'available') {
          if (this.props.date < dd) state = 'unavailable';
          else state = availabilities[i - 1].type;
        } else {
          state = availabilities[i - 1].type;
        }
      } else {
        state = 'none';
      }
      numbers.push({
        availability: state,
        day: i,
        id: availabilities.length > 0 && availabilities[i - 1] ? availabilities[i - 1].id : undefined,
      });
    }

    this.setState({
      padding: arr_padding,
      numbers,
      loadingData: availabilities.length > 0 ? false : true,
    });
  }

  async componentDidMount() {
    let changingDate = this.state.changingDate;
    const number = new Date(this.state.currentYear, this.state.currentMonth + 1, 0).getDate();
    for (let i = 0; i < number; i++) changingDate.push(false);
    this.setState({ changingDate, label_currentMonth: this.state.months[new Date().getMonth()] });
    this.loadData([]);

    const { data } = await getMonthAvailabilityByRoom(this.props.roomId, this.state.currentMonth, this.state.currentYear, number);
    this.loadData(data.data);
  }

  async lastMonth() {
    let { currentMonth, currentYear, label_currentMonth, months } = this.state;

    if (currentMonth === 0) { currentMonth = 12; currentYear -= 1 }
    currentMonth -= 1;
    label_currentMonth = months[currentMonth];
    this.setState({ currentMonth, currentYear, label_currentMonth });
    this.loadData([]);

    const { data } = await getMonthAvailabilityByRoom(this.props.roomId, currentMonth, currentYear, new Date(currentYear, currentMonth + 1, 0).getDate());
    this.loadData(data.data);
  }

  async nextMonth() {
    let { currentMonth, currentYear, label_currentMonth, months } = this.state;

    currentMonth += 1;
    if (currentMonth === 12) { currentMonth = 0; currentYear += 1 }
    label_currentMonth = months[currentMonth];
    this.setState({ currentMonth, currentYear, label_currentMonth });
    this.loadData([]);

    const { data } = await getMonthAvailabilityByRoom(this.props.roomId, currentMonth, currentYear, new Date(currentYear, currentMonth + 1, 0).getDate());
    this.loadData(data.data);
  }

  async componentWillReceiveProps() {
    const { date } = this.props;
    if (date.getFullYear() === this.state.currentYear && date.getMonth() === this.state.currentMonth) {
      this.setState({ loadingData: true });
      const { data } = await getMonthAvailabilityByRoom(this.props.roomId, this.state.currentMonth, this.state.currentYear, new Date(this.state.currentYear, this.state.currentMonth + 1, 0).getDate());
      this.loadData(data.data);
    }
  }

  async dayClicked(index) {
    const changingDate = this.state.changingDate;

    try {
      const { numbers } = this.state;
      const today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
      console.log('Day clicked!', numbers, index, numbers[index]);
      if (numbers[index].availability === 'available' || numbers[index].availability === 'unavailable') {
        if (today > new Date(this.state.currentYear, this.state.currentMonth, index)) {
          return alert('No pots bloquejar una data anterior avui');
        } else {
          changingDate[index] = true;
          this.setState({ changingDate });
          const res = await this.props.onDayClicked(new Date(this.state.currentYear, this.state.currentMonth, index + 1), 'book', numbers[index].id);
          if (res) numbers[index].availability = 'blocked';
        }
      } else if (numbers[index].availability === 'blocked') {
        if (today > new Date(this.state.currentYear, this.state.currentMonth, index)) {
          return alert('No pots desbloquejar una data anterior avui');
        } else {
          changingDate[index] = true;
          this.setState({ changingDate });
          const res = await this.props.onDayClicked(new Date(this.state.currentYear, this.state.currentMonth, index + 1), 'cancelBook', numbers[index].id);
          if (res) numbers[index].availability = 'available';
        }
      } else if (numbers[index].availability === 'booked') {

        this.setState({ changingDate: false });
        return alert('No pots bloquejar un día reservat per algú');
      } else if (numbers[index].availability === 'prebooked') {
        if (today > new Date(this.state.currentYear, this.state.currentMonth, index)) {
          return alert('No pots bloquejar una data anterior avui');
        } else {
          changingDate[index] = true;
          this.setState({ changingDate });
          const res = await this.props.onDayClicked(new Date(this.state.currentYear, this.state.currentMonth, index + 1), 'blockPreBooking', numbers[index].id);
          if (res) numbers[index].availability = 'blocked';
        }
      }

      changingDate[index] = false;
      this.setState({ numbers, changingDate });
    } catch (err) {
      changingDate[index] = false;
      this.setState({ changingDate: false });
    }
  }

  updateCalendar = (date) => {
    const first_day = new Date(this.state.currentYear, this.state.currentMonth, 1);
    const last_day = new Date(this.state.currentYear, this.state.currentMonth + 1, 0);

    let padding = first_day.getDay();
    if (padding === 0) padding = 6;
    else padding -= 1;
    const arr_padding = [];
    for (let i = 0; i < padding; i++) arr_padding.push({});

    let numbers = [];
    for (let i = 1; i <= last_day.getDate(); i++) {
      numbers.push({
        availability: date.getTime() >= new Date(this.state.currentYear, this.state.currentMonth, i).getTime() ? 'available' : 'unavailable',
        day: i
      });
    }

    this.setState({ padding: arr_padding, numbers });
  }

  render() {
    return (
      <div className="calendar-container">
        <div className="calendar-header">
          <div className="calendar-navigation">
            <div className="prev" onClick={() => this.lastMonth()}>&#10094;</div>
            {
              this.state.loadingData
                ? <Icon name={'loading'} style={{ color: 'white', padding: 8 }} />
                : <p>{this.state.label_currentMonth} <span>{this.state.currentYear}</span></p>
            }
            <div className="next" onClick={() => this.nextMonth()}>&#10095;</div>
          </div>

          <ul className="weekdays">
            {this.state.days.map((day, index) => <li key={index}><p>{day}</p></li>)}
          </ul>
        </div>

        <ul className="days">
          {
            this.state.padding.map((item, index) => <li key={`p-${index}`}></li>)
          }
          {
            this.state.numbers.map((day, index) => (
              <li key={`d-${index}`} onClick={() => this.dayClicked(index)}>
                <div className={[
                  this.state.loadingData
                    ? 'none'
                    : day.availability === 'available'
                      ? 'active'
                      : day.availability === 'booked'
                        ? 'inactive'
                        : day.availability === 'blocked'
                          ? 'blocked'
                          : day.availability === 'manualBooking'
                            ? 'manualBooking'
                            : day.availability === 'prebooked'
                              ? 'prebooked'
                              : 'unavailable'

                  , (day.day === new Date().getDate()
                    && this.state.currentMonth === new Date().getMonth()
                    && this.state.currentYear === new Date().getFullYear()) && 'today'
                ].join(' ')}>
                  {
                    this.state.changingDate[index]
                      ? <Icon name={'loading'} />
                      : <p>{day.day}</p>
                  }
                </div>
              </li>
            ))
          }
        </ul>

      </div>
    );
  }
}

export default GCalendar;



// WEBPACK FOOTER //
// ./src/components/GCalendar/GCalendar.js